import React from 'react';
import styles from './PagesHeader.styles.scss';
import { Breadcrumbs } from '../../Breadcrumbs';
import cn from 'classnames';

const PagesHeader = ({
  title,
  routes,
  withBreadcrumb,
  titleClassName,
  wrapperClassName,
  withActionButton,
  action,
  isTaxReturn,
  children,
}) => {
  return (
    <div>
      {withBreadcrumb && (
        <Breadcrumbs isTaxReturn={isTaxReturn} routeNames={routes} />
      )}
      {children}

      <div
        className={cn(
          'd-flex flex-column flex-md-row align-items-center justify-content-between w-100',
          styles.header,
          title && styles.container,
          wrapperClassName,
          titleClassName,
          withBreadcrumb ? 'mt-0' : '',
        )}
      >
        <p className={cn(styles.title, titleClassName)}>{title}</p>
        {withActionButton && action}
      </div>
    </div>
  );
};

export default React.memo(PagesHeader);
